import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee, Steps } from "@/components/site/Steps";
import { Services } from "@/components/site/Services";
import { QuoteSection } from "@/components/site/QuoteForm";
import { Footer, MobileBar } from "@/components/site/Footer";

export default function Landing() {
  return (
    <div className="dir-3 font-body bg-ground text-ink">
      <Header />
      <main id="top">
        <Hero />
        <Marquee />
        <Steps />
        <Services />
        <QuoteSection />
      </main>
      <Footer />
      <MobileBar />
    </div>
  );
}
